import axios from "axios";
import store from "../redux/store";
import {
    logout
} from "../redux/ducks/session";

//AXIOS RESPONSE
axios.interceptors.response.use(
    response => response,
    error => {
        /* If authorization failed (such as token invalid) */
        if (error.response.status == 401) store.dispatch(logout());
        return Promise.reject(error);
    }
);